export enum ShippingBoxTheme {
  Light = 'light',
  Dark = 'dark'
}
